import React, { useMemo } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
  useParams
} from 'react-router-dom';
import RingCustomizerContainer from './pages';
import URLScreening from './pages/URLScreening';
import type { ICustomizerHOCProps } from './components/RingCustomizerHOC';

function createHistory(navigate: ReturnType<typeof useNavigate>) {
  return {
    push: (to: string) => {
      navigate(to);
    },
    replace: (to: string) => {
      navigate(to, { replace: true });
    },
    goBack: () => {
      navigate(-1);
    }
  };
}

function RingCustomizerRoute({ type }: { type: 1 | 2 | 3 }) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const history = useMemo(() => createHistory(navigate), [navigate]);
  const match = {
    params,
    isExact: true,
    path: location.pathname,
    url: location.pathname
  };
  const hocProps: ICustomizerHOCProps = {
    type,
    location,
    history,
    match
  };
  return <RingCustomizerContainer {...hocProps} />;
}

function URLScreeningRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const history = useMemo(() => createHistory(navigate), [navigate]);
  const match = {
    params,
    isExact: true,
    path: '*',
    url: location.pathname
  };
  return <URLScreening match={match} location={location} history={history} />;
}

const DEFAULT_REDIRECT =
  '/helzberg/rings/profiles/D/widths/7/ring_materials/14KW?ring_finish=SATIN&finish_type=F&weight=P&size=10&feature_group=N&sleeve=NONE';

function App() {
  return (
    <div className="tw-flex tw-flex-col app-container">
      <BrowserRouter>
        <Routes>
          <Route
            path="/rings/profiles/:profile/widths/:width/ring_materials/:ring_materials"
            element={<RingCustomizerRoute type={1} />}
          />
          <Route
            path="/:pathPrefix/rings/profiles/:profile/widths/:width/ring_materials/:ring_materials"
            element={<RingCustomizerRoute type={1} />}
          />
          <Route
            path="/women/rings/styles/:styles/ring_materials/:ring_materials/color_arrangements/:color_arrangements/stone_quantities/:stone_quantities/variants/:variants"
            element={<RingCustomizerRoute type={2} />}
          />
          <Route
            path="/:pathPrefix/women/rings/styles/:styles/ring_materials/:ring_materials/color_arrangements/:color_arrangements/stone_quantities/:stone_quantities/variants/:variants"
            element={<RingCustomizerRoute type={2} />}
          />
          <Route
            path="/rings/:ring_type/ring_materials/:ring_materials"
            element={<RingCustomizerRoute type={3} />}
          />
          <Route
            path="/:pathPrefix/rings/:ring_type/ring_materials/:ring_materials"
            element={<RingCustomizerRoute type={3} />}
          />
          <Route path="/" element={<Navigate to={DEFAULT_REDIRECT} replace />} />
          <Route path="*" element={<URLScreeningRoute />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
